import React, { createContext, useContext } from "react";
import HyroTable from "@hyro-components/hyro-table/HyroTable";
import {
  BENCHMARKS_TABLE_COLUMNS,
  BENCHMARK_TYPES,
  BENCHMARK_VALIDATION_ERROR
} from "./AnalyticsSettings.consts";
import { getOverrideTypeColumn } from "./AnalyticsSettings.utils";
import EditableMetricCell from "./EditableMetricCell";

const BENCHMARK_MAX = 100;

const BenchmarkUpdateContext = createContext(null);

const BenchmarkEditCell = (params) => {
  const onBenchmarkUpdate = useContext(BenchmarkUpdateContext);
  return (
    <EditableMetricCell
      {...params}
      max={BENCHMARK_MAX}
      errorMessage={BENCHMARK_VALIDATION_ERROR}
      helperText={`Default ${params.row.defaultBenchmark}%`}
      onCommit={(num) => onBenchmarkUpdate(params.row.id, num)}
    />
  );
};

const benchmarkColumn = {
  ...BENCHMARKS_TABLE_COLUMNS[1],
  editable: true,
  renderEditCell: (params) => <BenchmarkEditCell {...params} />,
  renderCell: ({ value }) => `${value} %`
};

const typeColumn = getOverrideTypeColumn(BENCHMARKS_TABLE_COLUMNS[2]);

const columns = [BENCHMARKS_TABLE_COLUMNS[0], benchmarkColumn, typeColumn];

const formatRows = (benchmarks) =>
  benchmarks.map((b) => ({
    id: b.metricId,
    metricName: b.metricName,
    benchmark: Math.round(b.benchmark * 100),
    defaultBenchmark: Math.round(b.defaultBenchmark * 100),
    type: b.isOverridden ? BENCHMARK_TYPES.CUSTOM : BENCHMARK_TYPES.DEFAULT,
    isOverridden: b.isOverridden
  }));

const BenchmarksTable = ({ benchmarks, loading, onBenchmarkUpdate }) => {
  const rows = benchmarks ? formatRows(benchmarks) : [];

  return (
    <BenchmarkUpdateContext.Provider value={onBenchmarkUpdate}>
      <HyroTable
        columns={columns}
        rows={rows}
        loading={loading}
        disableColumnSorting
        testId="benchmarks"
        minHeight={1}
        dataGridProps={{ autoHeight: true }}
      />
    </BenchmarkUpdateContext.Provider>
  );
};

export default BenchmarksTable;
